import React from 'react';

import moment from 'moment';

import Tooltip from '../../../../../Tooltip';

export default function DatePaid({ invoice }) {
  if (invoice?.status !== 'paid') {
    return null;
  }

  let tooltipMessage = '';

  switch (invoice?.not_overdue_reason) {
    case 'SERVICING_TRANSFER':
      tooltipMessage =
        'This invoice will show as having been paid on time in reporting despite the date paid being after the overdue date. Reason: The payment occurred during the servicing transfer window.';
      break;
    case 'PRIOR_SERVICER_DATA':
      tooltipMessage =
        "This invoice will show as having been paid on time in reporting despite the date paid being after the overdue date. Reason: We have reason to believe the prior servicer's payment dates are inaccurate.";
      break;
    case 'SERVICER_COLLECTION_ERROR':
      tooltipMessage =
        'This invoice will show as having been paid on time in reporting despite the date paid being after the overdue date. Reason: We made a clerical error collecting the payment and the borrower would have otherwise paid on time.';
      break;
    default:
      tooltipMessage = '';
  }

  return (
    <div>
      <div className="flex text-sm font-medium mb-1 items-center gap-2">
        Date paid
      </div>
      <div className="flex items-center">
        <div className="form-input border-0 shadow-none pr-2">
          {invoice?.date_paid
            ? moment(invoice.date_paid).format('MMM DD, YYYY')
            : ''}
        </div>
        {tooltipMessage && <Tooltip size="md">{tooltipMessage}</Tooltip>}
      </div>
    </div>
  );
}
